import { GKBilling } from "gkshared";

export const gkb = new GKBilling((process.env.APPLICATION_ID as string) || "");
